import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { signup } from "../../../assets/img";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import HttpsIcon from "@mui/icons-material/Https";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";


const Signup = () => {
      const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  const onSubmit = (data) => {
    console.log("Signup Data:", data);
  };

  return (
    <div className="login-page">

      {/* Floating Background Circles */}
      <div className="circle circle1"></div>
      <div className="circle circle2"></div>

      {/* CARD */}
      <div className="login-card">

        <h1 className="title">Create Account</h1>
        <p className="subtitle">Join now and explore premium features</p>

        <form onSubmit={handleSubmit(onSubmit)}>

          {/* Full Name */}
          <div className="input-box">
            <input
              type="text"
              required
              {...register("name", { required: "Name is required" })}
            />
            <label>Full Name</label>
            <PersonIcon className="toggle-pass" />
          </div>
          {errors.name && <p className="error-text">{errors.name.message}</p>}

          {/* Email */}
          <div className="input-box">
            <input
              type="email"
              required
              {...register("email", { required: "Email is required" })}
            />
            <label>Email Address</label>
            <EmailIcon className="toggle-pass" />
          </div>
          {errors.email && <p className="error-text">{errors.email.message}</p>}

          {/* Password */}
          <div className="input-box">
            <input
              type={showPassword ? "text" : "password"}
              required
              {...register("password", { required: "Password is required" })}
            />
            <label>Password</label>

            {showPassword ? (
              <VisibilityOffIcon
                className="toggle-pass"
                onClick={() => setShowPassword(!showPassword)}
              />
            ) : (
              <VisibilityIcon
                className="toggle-pass"
                onClick={() => setShowPassword(!showPassword)}
              />
            )}
          </div>

          {/* Confirm Password */}
          <div className="input-box">
            <input
              type={showCPassword ? "text" : "password"}
              required
              {...register("confirm_password", { required: "Confirm Password is required" })}
            />
            <label>Confirm Password</label>

            {showCPassword ? (
              <VisibilityOffIcon
                className="toggle-pass"
                onClick={() => setShowCPassword(!showCPassword)}
              />
            ) : (
              <VisibilityIcon
                className="toggle-pass"
                onClick={() => setShowCPassword(!showCPassword)}
              />
            )}
          </div>

          {/* Button */}
          <button className="login-btn"  onClick={() => navigate("/")}>Sign Up</button>
        </form>

        <p className="bottom-text">
          Already have an account? <span>Login</span>
        </p>
      </div>

      {/* Right Side Image */}
      <img src={signup} className="right-img" alt="signup" />
    </div>
  );
};

export default Signup;
